import { baseFeatures } from 'reactApp/constants/products/baseFeatures';
import { quotaFeatures } from 'reactApp/constants/products/quotaFeatures';

export const features = {
    ...baseFeatures,
    ...quotaFeatures,
};
